import React from 'react';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';
import Icon from 'src/components/icon';
import SelectReact from 'react-select';
import { find } from 'lodash';

import './select.scss';

const Select = ({
    input,
    label,
    meta = {},
    theme,
    loading = false,
    className,
    showSuccessIcon = false,
    options = [],
    disabled = false,
    groupOptions = null,
    ...rest
}) => {
    console.log('input', groupOptions);
    console.log(find(options, el =>
        /* eslint-disable */
         el.value == input.value
    ))  
    return (
        <div className={classnames(
            'SelectWrapper',
            theme,
            { hasError: (meta.touched && meta.error) },
        )}
        >
            <label htmlFor={rest.id}>{label}</label>
            <div style={{ position: 'relative' }}>
                <SelectReact
                    noOptionsMessage={() => 'Nenhuma opção'}
                    className={classnames(
                        'Select',
                        className,
                    )}
                    data-tip={meta.error}
                    options={groupOptions ? groupOptions : options}
                    isLoading={loading}
                    isDisabled={disabled}
                    {...input}
                    {...rest}
                    onChange={props => (input.onChange ? input.onChange(props ? props.value : null) : null)}
                    onBlur={props => (input.onBlur ? input.onBlur(props ? props.value : null) : null)}
                    value={find(options, el =>
                        /* eslint-disable */
                         el.value == input.value
                    ) || null}
                />
                {
                    !meta.error && input.value && (
                        <Icon code="times" className="input-icon remove" size={14} onClick={() => { input.onChange ? input.onChange(null) : null }}/>
                    )
                }
                {meta.touched
                    && meta.error && (
                        <Icon code="times" className="input-icon error" size={12} />
                )}
                {meta.touched
                    && !meta.error
                    && showSuccessIcon && (
                        <Icon code="check" className="input-icon success" size={12} />
                )}
            </div>
            {meta.touched
                && meta.error
                && meta.active && (
                    <ReactTooltip
                        type="error"
                        effect="solid"
                        place="top"
                        event="focus"
                    />
            )}
        </div>
    );
}

export default Select;
